import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/reports/'
)({
  component: () => (
    <Navigate to='/incidents/reports/executive-summary' replace />
  ),
})

